import { FC } from 'react'
import { useAtomValue } from 'jotai'
import { useTar } from '@/modules/i18n'
import { DatabaseSchema } from '@/components/DataWorkspace/DatabaseSchema'
import { workspaceTaskAtom } from '@/store/workspaceAtoms'

export const SchemaTab: FC = () => {
  const { t } = useTar()
  const task = useAtomValue(workspaceTaskAtom)
  const tableQueries = task?.tableQueries ?? []

  return (
    <div className="p-4 lg:p-6 h-full min-h-0 flex flex-col">
      <div className="mb-4">
        <h2 className="text-2xl font-semibold">{t('challenges.schema')}</h2>
      </div>
      <div className="flex-1 min-h-0 overflow-auto custom-scrollbar">
        <DatabaseSchema tableQueries={tableQueries} />
      </div>
    </div>
  )
}

